<template>
  <v-form>
    <v-progress-linear v-if="loading" indeterminate color="blue"></v-progress-linear>
    <v-card>
      <HeaderDividerBlock headerText="Create New Role"></HeaderDividerBlock>
      <v-container class="pa-6">
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="12">
            <v-text-field outlined dense v-model="form.name" required label="Role Name*" :error-messages="this.fieldErrors.name"></v-text-field>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="6" xl="3">
            <v-simple-table v-if="projectPer.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllProject"
                        @change="toggleSelectAll('project')"
                        label="Project"
                        :indeterminate="isProjectIndeterminate"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in projectPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.project"
                        :label="formatLabel(item)"
                        :value="item"
                        @change="updateSelectAll('project')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="6" xl="3">
            <v-simple-table v-if="taskPer.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllTask"
                        @change="toggleSelectAll('task')"
                        label="Task"
                        :indeterminate="isTaskIndeterminate"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in taskPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.task"
                        :label="formatLabel(item)"
                        :value="item"
                        @change="updateSelectAll('task')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="6" xl="3">
            <v-simple-table v-if="customerPer.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllCustomer"
                        @change="toggleSelectAll('customer')"
                        label="Customer"
                        :indeterminate="isCustomerIndeterminate"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in customerPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.customer"
                        :label="formatLabel(item)"
                        :value="item"
                        @change="updateSelectAll('customer')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="6" xl="3">
            <v-simple-table v-if="settingsPer.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllSettings"
                        @change="toggleSelectAll('settings')"
                        label="Settings"
                        :indeterminate="isSettingsIndeterminate"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in settingsPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.settings"
                        :label="formatLabel(item)"
                        :value="item"
                        @change="updateSelectAll('settings')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="6" xl="3">
            <v-simple-table v-if="invoicePer.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllInvoice"
                        @change="toggleSelectAll('invoice')"
                        label="Invoice"
                        :indeterminate="isInvoiceIndeterminate"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in invoicePer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.invoice"
                        :label="formatLabel(item)"
                        :value="item"
                        @change="updateSelectAll('invoice')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="6" xl="3">
            <v-simple-table v-if="documentPer.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllDocument"
                        @change="toggleSelectAll('document')"
                        label="Document"
                        :indeterminate="isDocumentIndeterminate"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in documentPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.document"
                        :label="formatLabel(item)"
                        :value="item"
                        @change="updateSelectAll('document')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="6" xl="3">
            <v-simple-table v-if="calendarPer.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllCalendar"
                        @change="toggleSelectAll('calendar')"
                        label="Calendar"
                        :indeterminate="isCalendarIndeterminate"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in calendarPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.calendar"
                        :label="formatLabel(item)"
                        :value="item"
                        @change="updateSelectAll('calendar')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6"> </v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="#00B3FF" dark depressed :disabled="loading" block @click="create">Create</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <Snackbars :text="successMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="closeSnackbar" />
    <Snackbars :text="'Validation error please scroll up'" :snackbar="snackbarError" :color="'red'" @classSnackbar="closeSnackbar" />
  </v-form>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { RoleService } from "@/services/role-service.js";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock.vue";

export default {
  name: "CreateRole",
  props: ["name"],
  components: {
    Alert,
    Snackbars,
    HeaderDividerBlock
  },
  data() {
    return {
      form: {
        name: "",
        project: [],
        task: [],
        customer: [],
        settings: [],
        invoice: [],
        document: [],
        calendar: []
      },
      loading: false,
      errors: [],
      successMsg: "",
      snackbar: false,
      snackbarError: false,
      projectPer: [],
      taskPer: [],
      customerPer: [],
      settingsPer: [],
      invoicePer: [],
      documentPer: [],
      calendarPer: [],
      selectAllProject: false,
      selectAllTask: false,
      selectAllCustomer: false,
      selectAllSettings: false,
      selectAllInvoice: false,
      selectAllDocument: false,
      selectAllCalendar: false,
      fieldErrors: [],
    };
  },
  mounted() {
    this.getPermissionList();
  },

  computed: {
    isProjectIndeterminate() {
      return this.form.project.length > 0 && this.form.project.length < this.projectPer.length;
    },
    isTaskIndeterminate() {
      return this.form.task.length > 0 && this.form.task.length < this.taskPer.length;
    },
    isCustomerIndeterminate() {
      return this.form.customer.length > 0 && this.form.customer.length < this.customerPer.length;
    },
    isSettingsIndeterminate() {
      return this.form.settings.length > 0 && this.form.settings.length < this.settingsPer.length;
    },
    isInvoiceIndeterminate() {
      return this.form.invoice.length > 0 && this.form.invoice.length < this.invoicePer.length;
    },
    isDocumentIndeterminate() {
      return this.form.document.length > 0 && this.form.document.length < this.documentPer.length;
    },
    isCalendarIndeterminate() {
      return this.form.calendar.length > 0 && this.form.calendar.length < this.calendarPer.length;
    }
  },

  methods: {
    create() {
      this.loading = true;
      this.errors = null;

      const perArray = [
        ...this.form.project,
        ...this.form.task,
        ...this.form.customer,
        ...this.form.settings,
        ...this.form.invoice,
        ...this.form.document,
        ...this.form.calendar,
      ];

      let fd = new FormData();

      fd.append("name", this.form.name);
      fd.append("guard_name", this.form.guard_name);
      fd.append("permissions", perArray.join(",") || "");

      RoleService.createRole(fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.reset();
            this.snackbar = true;
            this.snackbarError = false;
            this.$router.push("/roles");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.fieldErrors = data.errors;
          this.errors = errorOutput;
          window.scrollTo(0, 0);
        });
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    toggleSelectAll(type) {
      const allItems = this[`${type}Per`];
      this.form[type] = this[`selectAll${type.charAt(0).toUpperCase() + type.slice(1)}`] ? allItems.slice() : [];
    },
    updateSelectAll(type) {
      const allItems = this[`${type}Per`];
      const selectedItems = this.form[type];
      this[`selectAll${type.charAt(0).toUpperCase() + type.slice(1)}`] = selectedItems.length === allItems.length;
    },
    getPermissionList() {
      this.loading = true;
      RoleService.getPermissionList()
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.permissions = response.data;

            this.userPer = [];
            this.projectPer = [];
            this.customerPer = [];
            this.taskPer = [];
            this.calendarPer = [];
            this.invoicePer = [];
            this.documentPer = [];
            this.settingsPer = [];

            this.projectPer = this.permissions.project;
            this.customerPer = this.permissions.customer;
            this.taskPer = this.permissions.task;
            this.calendarPer = this.permissions.calendar;
            this.invoicePer = this.permissions.invoice;
            this.documentPer = this.permissions.document;
            this.settingsPer = this.permissions.setting;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },

    reset() {
      this.form = [];
    },
    formatLabel(label) {
      const parts = label.split(".");
      const formattedLabel = parts[parts.length - 1].replace(/_/g, " ");
      return formattedLabel.charAt(0).toUpperCase() + formattedLabel.slice(1);
    },

  },
};
</script>
